<template>
  <div class="camera-device">
    <!--    <ion-select-->
    <!--        class="camera-select"-->
    <!--        aria-label="Camera Device"-->
    <!--        placeholder="Select Camera Device"-->
    <!--        label="Select Camera Device"-->
    <!--        label-placement="floating"-->
    <!--        fill="outline"-->
    <!--        :disabled="props.cameras.length === 0"-->

    <!--        @ionChange="onCameraChange">-->
    <!--      <ion-select-option-->
    <!--          v-for="camera in props.cameras"-->
    <!--          :value="camera.deviceId">-->
    <!--        {{ camera.label }}-->
    <!--      </ion-select-option>-->
    <!--    </ion-select>-->
    <select @change="onCameraChange($event)">
      <option v-for="camera in cameraList" :value="camera.deviceId" :selected="isSelected(camera.deviceId)">
        {{ camera.label }}
      </option>
    </select>
  </div>
</template>

<script setup>
import {useStore} from 'vuex';
import {computed, getCurrentInstance} from "vue";
import constant from "@/constant";


// loading the image capture and submit library
const instance = getCurrentInstance();
const globalEmitter = instance.appContext.config.globalProperties.$globalEmitter;

const store = useStore();
const cameraList = computed(() => store.getters['Monitoring/cameraDeviceList']);

const onCameraChange = (event) => {
  const updateCameraDevice = () => {
    let cameraId = event.target.value;
    store.dispatch('Monitoring/setCameraId', cameraId)
    globalEmitter.emit('camera-change', cameraId)
  }

  switch (store.getters.testState) {
    case constant.STATUS_TEST_INTRO:
      updateCameraDevice();
      break;
    case constant.STATUS_TEST_IN_PROGRESS:
      if (store.state.Monitoring.cameraMonitoringStarted === false) {
        //update camera only if camera monitoring is not started
        updateCameraDevice();
      }
      break;
  }


}


const isSelected = (deviceId) => {
  let selectedCameraId = store.getters['Monitoring/cameraId']
  if (selectedCameraId == null) {
    selectedCameraId = cameraList.value[0].deviceId
  }
  let result = selectedCameraId === deviceId;
  return result;
}
</script>

<style lang="scss" scoped>
.camera-device {
  display: flex;
  justify-content: center;

  select {
    width: 100%;
  }
}

</style>